import styled from 'styled-components';

import Skeleton from '@/components/atom/Skeleton';
import theme from '@/styles/theme';

const DoctorDetailSkeleton = () => {
  return (
    <Wrapper>
      <Card>
        <Row style={{ justifyContent: 'center', marginBottom: 24 }}>
          <Image src={'/images/doctor/doctor_default_profile.png'} alt={'default_image'} />
        </Row>
        <Row style={{ justifyContent: 'center' }}>
          <Col>
            <Skeleton style={{ width: '20%', height: 18, marginBottom: 8 }} />
            <Skeleton style={{ width: '30%', height: 30, marginBottom: 8 }} />
            <Row style={{ marginBottom: 16 }}>
              <Skeleton style={{ width: '20%', height: 18, marginRight: 8 }} />
              <Skeleton style={{ width: '20%', height: 18, marginRight: 8 }} />
              <Skeleton style={{ width: '20%', height: 18, marginRight: 8 }} />
            </Row>
          </Col>
        </Row>
        <Divider style={{ marginBottom: 16 }} />
        <Row style={{ marginBottom: 8 }}>
          <Skeleton style={{ width: '15%', height: 20, marginRight: 8 }} />
          <Skeleton style={{ width: '15%', height: 20, marginRight: 8 }} />
        </Row>
        <Row>
          <Skeleton style={{ width: '10%', height: 20, marginRight: 8 }} />
          <Skeleton style={{ width: '30%', height: 20, marginRight: 8 }} />
        </Row>
      </Card>

      <Tabs>
        <Skeleton style={{ width: '18%', height: 30, marginRight: 10 }} />
        <Skeleton style={{ width: '25%', height: 30, marginRight: 10 }} />
        <Skeleton style={{ width: '20%', height: 30, marginRight: 10 }} />
        <Skeleton style={{ width: '25%', height: 30, marginRight: 10 }} />
      </Tabs>
      <Section>
        <Skeleton style={{ width: '20%', height: 30, marginBottom: 10 }} />
        <Skeleton style={{ width: '80%', height: 20, marginBottom: 10 }} />
        <Skeleton style={{ width: '80%', height: 20, marginBottom: 10 }} />
        <Skeleton style={{ width: '80%', height: 20, marginBottom: 10 }} />
        <Skeleton style={{ width: '80%', height: 20, marginBottom: 10 }} />
      </Section>
      <Section>
        <Skeleton style={{ width: '20%', height: 30, marginBottom: 10 }} />
        <Skeleton
          style={{
            width: '100%',
            height: 300,
            marginBottom: 10,
          }}
        />
      </Section>
    </Wrapper>
  );
};

export default DoctorDetailSkeleton;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 24px;
`;

const Card = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  margin: 8px 0px 20px 0px;
`;

const Col = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.color.gray40};
`;

const Tabs = styled(Row)`
  width: 100%;
  margin-top: 20px;
`;

const Section = styled(Col)`
  margin-top: 30px;
`;

const Image = styled.img`
  height: 240px;
`;
